import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=4010eefc&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4010eefc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4010eefc')) {
      api.createRecord('4010eefc', component.options)
    } else {
      api.reload('4010eefc', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=4010eefc&scoped=true&", function () {
      api.rerender('4010eefc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4pEkAqf7UlD84/JS/comp/Voucher-Unit.vue"
export default component.exports